(function ($) {
  $(function () {
    const $carrierValue = $("#carrier-filter");
    const $holidayValue = $("#holiday-filter");
    const $icons = $(".c-carrier-schedule__icons");
    const $resultsContainer = $("#results-container");
    const $results = $("#results");

    function dataMatches(carrier, holiday) {
      let iconType = $(
        'span[data-holiday="' + holiday + '"][data-carrier="' + carrier + '"]'
      );

      $icons.removeClass("selected");
      $(
        'td[data-holiday="' + holiday + '"][data-carrier="' + carrier + '"]'
      ).addClass("selected");

      const render = {
        "icon--closed": "Closed",
        "icon--limited": "Limited Operations",
        "icon--open": "Open",
      };
      const className = iconType.attr("class");

      $results.text(render[className]);
      $resultsContainer.removeClass(Object.keys(render).join(" "));
      $resultsContainer.addClass(className);
    }

    function updateSelected($target) {
      let carrier = $carrierValue.val();
      let holiday = $holidayValue.val();

      $icons.removeClass("selected");
      $target.addClass("selected");

      if (carrier && holiday) {
        dataMatches(carrier, holiday);
      }
    }

    $carrierValue.on("change", function () {
      updateSelected($('td[data-carrier="' + $(this).val() + '"]'));
    });

    $holidayValue.on("change", function () {
      updateSelected($('td[data-holiday="' + $(this).val() + '"]'));
    });
  });
})(jQuery);
